define('ordersDetailMessagesBodyMessageAttachmentView',[
  'module',
  'backbone',
  'underscore',
  'marionette',
  'galleryView',
  'pdfView',
  'template!ordersDetailMessagesBodyMessageAttachmentView'
], function (
  Module,
  Backbone,
  _,
  Marionette,
  GalleryView,
  PdfView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'message-attachment-view',

    events: {
      'click .zoom-button': 'onZoom',
      'click .download-button': 'onDownload'
    },

    serializeData: function () {
      var data = {
        src:'',
        name: '',
        canZoom: false
      };

      if(this.model.get('fileLink') && this.model.get('fileName') && this.model.get('fileName').match(/\.(jpg|jpeg|png|gif)$/i))
        data.src = this.model.get('fileLink');
      else
        data.name = this.model.get('fileName');

      if(this.model.get('fileLink') && this.model.get('fileName') && this.model.get('fileName').match(/\.(jpg|jpeg|png|gif|pdf)$/i))
        data.canZoom = true;

      data.downloadLink = '';
      if (this.model.get('downloadLink'))
        data.downloadLink = this.model.get('downloadLink');

      return data;
    },

    //attach popover to the view to show image with this.model.get('fileLink')
  
    onRender: function () {
      if (this.model.get('fileLink') && this.model.get('fileName') && this.model.get('fileName').match(/\.(jpg|jpeg|png|gif)$/i)) {
        this.$el.popover({
          trigger: 'hover',
          placement: 'top',
          html: true,
          container: 'body',
          content: '<img src="' + this.model.get('fileLink') + '" class="popover-zoom" />'
        });
      }
    },

    onDownload: function (e) {
      e.stopPropagation();

      if(this.model.get('downloadLink') === '')
        return;

      var anchor = document.createElement('a');
      anchor.href = this.model.get('downloadLink');
      anchor.target = '_blank';
      anchor.download = this.model.get('fileName');
      anchor.click();
    },

    onZoom: function (e) {
      e.stopPropagation();

      var fileLink = this.model.get('fileLink').replace('params=t', 'params=b');
      if (!fileLink) return;

      var fileName = this.model.get('fileName') || 'Attachment';
      var fileType = '';
      if (fileName) {
        var fileItems = fileName.split('.');
        if (fileItems.length > 1)
          fileType = fileItems[fileItems.length - 1].toLowerCase();
      }

      if (fileType === 'pdf') {
        PdfView.prototype.open({
          url: fileLink.replace('&action=preview', ''),
          title: fileName
        });
      } else {
        var model = new Backbone.Model({urls: [fileLink]});
        require(['windows'], function (Windows) {
          Windows.open({
            view: function () {
              return new GalleryView({model: model});
            },
            id: 'message.attachment:' + this.model.get('secId'),
            title: fileName,
            modal: true,
            height: '80%',
            width: '60%'
          });
        }.bind(this));
      }
    }
  });
});
